module.exports = __webpack_public_path__ + "static/media/eels-silhouette.3e89d9ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teamSilhouettes/eels-silhouette.svg
// module id = 1328
// module chunks = 0